import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useListUserLikedArtworks } from 'src/services/apollo/artwork'
import {
  type ArtworkPreviewFragment,
  ArtworkType,
} from 'src/services/apollo/generated/graphql'
import { OrderOption } from 'src/services/helpers/orderOptionParams'
import { usePersonalPageActiveArtwork } from 'src/stores/artwork-modal'
import { useQs } from 'src/utils/qs'
import ArtworkPreviewCardSimple from '../Artwork/ArtworkPreviewCardSimple'
import ArtworkDetailDialog from '../ArtworkDetail/ArtworkDetailDialog'
import BaseCursorPaging from '../CursorPaging/BaseCursorPaging'
import Empty from '../Empty'

const UserLikedArtworkList: FC<{ userId: string }> = ({ userId }) => {
  const { t } = useTranslation(['artwork'])
  const [{ before, after }, setQs] = useQs()

  const [activeArtwork, setActiveArtwork] = usePersonalPageActiveArtwork()

  return (
    <>
      <BaseCursorPaging
        useSWR={useListUserLikedArtworks}
        getConnection={r => r}
        pageSize={20}
        renderItem={(artwork: ArtworkPreviewFragment) => {
          return (
            <ArtworkPreviewCardSimple
              key={artwork.id}
              artwork={artwork}
              onArtworkClick={setActiveArtwork}
              showAuthor
              trackingArgs={{
                scene: 'likes',
                section: 'artwork',
                feed: OrderOption.newest,
              }}
            />
          )
        }}
        empty={<Empty description={t('artwork:no-content')} />}
        extraArgs={{
          userId,
          types: [ArtworkType.Default, ArtworkType.AnimatedArtwork],
        }}
        before={before}
        after={after}
        onCursorChange={setQs}
      />

      <ArtworkDetailDialog
        artwork={activeArtwork}
        open={!!activeArtwork}
        onClose={() => setActiveArtwork(undefined)}
      />
    </>
  )
}

export default UserLikedArtworkList
